import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <div className="bg-gray-900 py-12 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold mb-4 text-white">About Healthy Kitchen</h1>
          <p className="text-xl text-gray-300">
            Committed to serving healthy, delicious meals since 2015
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <img
              src="https://images.unsplash.com/photo-1466637574441-749b8f19452f?auto=format&fit=crop&q=80"
              alt="Restaurant interior"
              className="rounded-lg shadow-lg w-full h-[400px] object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-6"
          >
            <h2 className="text-3xl font-semibold text-cyan-100">Our Story</h2>
            <p className="text-gray-100">
              Founded with a passion for healthy living and exceptional food, Healthy Kitchen has been serving the community with nutritious, delicious meals made from the finest organic ingredients.
            </p>
            <p className="text-gray-100">
              Our team of expert chefs crafts each dish with care, ensuring that every meal not only tastes amazing but also contributes to your well-being.
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mt-16"
        >
          <h2 className="text-3xl font-semibold text-center mb-8 text-cyan-100">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg border border-gray-700">
              <h3 className="text-xl font-semibold mb-4 text-brand-400">Quality</h3>
              <p className="text-gray-100">
                We source only the finest organic ingredients from local suppliers.
              </p>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg border border-gray-700">
              <h3 className="text-xl font-semibold mb-4 text-brand-400">Health</h3>
              <p className="text-gray-100">
                Every dish is crafted to provide optimal nutrition without compromising taste.
              </p>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg border border-gray-700">
              <h3 className="text-xl font-semibold mb-4 text-brand-400">Community</h3>
              <p className="text-gray-100">
                We're committed to serving and supporting our local community.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;